module.exports = __webpack_public_path__ + "img/wood_bobocoin.gm.a7b88fb.png";